import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/stock-watch`;

export async function getWatchlist() {
  const res = await apiFetch(`${BASE_URL}/user`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function createWatch(payload) {
  const res = await apiFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function updateWatch(id, payload) {
  const res = await apiFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function deleteWatch(id) {
  return apiFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
}
